<!-- 订单那详情 -->
<template>
  <div class="orderDetail">
    <div class="line time">
      该订单剩余体验时间为：<span style="color: crimson; font-weight: bold">{{
        time
      }}</span>
    </div>
    <div class="line">订单编号：{{ order_no }}</div>
    <div class="line">设备编号：{{ equipment_no }}</div>
    <div class="line">订单金额：{{ money }}</div>
    <div class="btn_block">
      <div class="btn" @click="handleApplyRefund">申请退款</div>
    </div>

    <!-- 弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      custom-class="dialogMessage"
      :show-close="false"
    >
      <!-- label-width="80px" -->
      <el-form ref="form" :model="form" inline :rules="rules">
        <el-form-item label="联系人" prop="name">
          <el-input v-model="form.name" placeholder="请输入联系人"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="contact">
          <el-input
            v-model="form.contact"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="申请内容" prop="re_mark">
          <el-input
            v-model="form.re_mark"
            placeholder="请输入申请内容"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {

  data() {
    return {
      time: "",
      order_id: "",
      open_id: "",
      timer: null,
      order_no: "",
      equipment_no: "",
      money: "",

      dialogVisible: false,
      form: {
        name: "", //联系人
        contact: "", // 手机号
        re_mark: "", // 申请内容
      },
      rules: {
        name: [{ required: true, trigger: "blur", message: "请输入联系人" }],
        contact: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          }
        ],
        re_mark: [
          { required: true, trigger: "blur", message: "请输入申请内容" },
        ],
      },
    };
  },

  mounted() {
    this.order_id = this.$route.query.order_id;
    this.order_no = this.$route.query.order_no;
    this.equipment_no = this.$route.query.equipment_no;
    this.money = this.$route.query.money;
    this.getList();
  },
  beforeDestroy() {
    clearInterval(this.timer); // 组件销毁时清除定时器
  },
  methods: {
    // 获取剩余时间的秒数
    getList() {
      axios({
        method: "get",
        url: "https://htapi.zxznzy.com/project/adult_h5_order_detail",
        params: {
          order_id: this.order_id,
          open_id:
            localStorage.getItem("open_id") || "ovA4QwV_eRGr6CkA1VEjathmNwx8", // 用户open_id
        },
      })
        .then((res) => {
          if (res.data.code == 1) {
            this.startCountdown(res.data.data.remain_seconds); // 启动倒计时
          } else {
            this.$message.error("获取订单列表失败：" + res.data.message);
          }
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
    //点击申请退款，打开弹窗
    handleApplyRefund() {
      this.form = {
        name: "", //联系人
        contact: "", // 手机号
        re_mark: "", // 申请内容
      };
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
      this.dialogVisible = true;
    },
    // 申请退款的确定
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          axios({
            method: "post",
            url: "https://htapi.zxznzy.com/project/wx_refund_back",
            data: {
              order_no: this.order_no,
              open_id:
                localStorage.getItem("open_id") ||
                "ovA4QwV_eRGr6CkA1VEjathmNwx8", // 用户open_id
              ...this.form,
            },
          })
            .then((res) => {
              if (res.data.code == 1) {
                this.$message.success("申请退款成功");
                this.dialogVisible = false;
              } else {
                this.$message.error("获取订单列表失败：" + res.data.message);
              }
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
              this.dialogVisible = false;
            });
        }
      });
    },
    // 倒计时主逻辑
    startCountdown(seconds) {
      this.remainingSeconds = seconds;
      this.updateTime();
      this.timer = setInterval(this.updateTime, 1000);
    },
    updateTime() {
      if (this.remainingSeconds <= 0) {
        clearInterval(this.timer);
        this.time = "00:00:00";
        this.$message.success("体验时间已结束");
        return;
      }
      this.time = this.secondsToHMS(this.remainingSeconds--);
    },
    // 秒数转HH:MM:SS（原方法保留）
    secondsToHMS(seconds) {
      const pad = (num) => num.toString().padStart(2, "0");
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;
      return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.orderDetail {
  background: linear-gradient(45deg, #b5e4f9, #a7cadd);
  background-size: cover;
  width: 100%;
  height: 98vh;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 20px;
  .line {
    margin-bottom: 20px;
  }
  .line.time {
    font-size: 20px;
  }

  .btn_block {
    display: flex;
    margin-top: 10px;
    padding-right: 10px;
    box-sizing: border-box;
    .btn {
      background-color: burlywood;
      color: #000;
      padding: 5px 15px;
      border-radius: 5px;
      cursor: pointer;
      &:hover {
        background-color: #ff7875;
      }
    }
  }
}

::v-deep {
  .el-dialog__body {
    padding: 30px 0 !important;
  }
  .dialogMessage {
    margin-top: 20vh !important;
    width: 90% !important;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      text-align: center;
      box-sizing: border-box;
      letter-spacing: 2px;
    }
  }
}
</style>
